module.exports = __webpack_public_path__ + "static/media/cliffs-and-lighthouse.49b1b336.png";